export interface ExtractedCounterpartyCandidate {
    id: string;
    name: string;
    workspaceId: string | null;
    email: string | null;
}

export interface MatchedExtractedCounterparty {
    id: string;
    name: string;
    email: string | null;
}

interface MatchExtractedCounterpartyParams {
    name: string;
    workspaceId: string;
    counterparties: ExtractedCounterpartyCandidate[];
}

export function isSameCounterpartyName(left: string, right: string) {
    const normalizedLeft = left.trim().toLowerCase();
    return (
        normalizedLeft !== "" && normalizedLeft === right.trim().toLowerCase()
    );
}

export function matchExtractedCounterparty({
    name,
    workspaceId,
    counterparties,
}: MatchExtractedCounterpartyParams): MatchedExtractedCounterparty | null {
    const matches = counterparties.filter((counterparty) =>
        isSameCounterpartyName(name, counterparty.name),
    );
    const localMatch = matches.find(
        (counterparty) => counterparty.workspaceId === workspaceId,
    );
    const match =
        localMatch ??
        matches.find((counterparty) => counterparty.workspaceId == null);
    if (!match) {
        return null;
    }

    return {
        id: match.id,
        name: match.name,
        email: match.email,
    };
}
